'use client';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';
import Navbar from '@/components/client/layout/Navbar';
import { useTranslation } from '@/hooks/useTranslation';

// Define the SVG as a new component
const EmptyStreetIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="250"
        height="113"
        viewBox="0 0 500.25 226"
        {...props}
    >
        {' '}
        {/* Adjusted size for better fit */}
        <g transform="translate(0 0)">
            <rect
                id="Rectangle_1856"
                data-name="Rectangle 1856"
                width="15.12"
                height="52.337"
                transform="translate(437.149 91.019)"
                fill="#f2f2f2"
            />
            <path
                id="Path_3730"
                data-name="Path 3730"
                d="M767.522,222.8l-36.773-43.748-73.815.675-44.778,43.614.9.582h-.323V314.64H767.423V223.922Z"
                transform="translate(-305.268 -89.289)"
                fill="#f2f2f2"
            />
            <path
                id="Path_3731"
                data-name="Path 3731"
                d="M803.094,179.238l-45.94,53.86v81.635H839.73V222.852Z"
                transform="translate(-377.576 -89.382)"
                fill="#e6e6e6"
            />
            <rect
                id="Rectangle_1857"
                data-name="Rectangle 1857"
                width="16.864"
                height="14.906"
                transform="translate(412.725 180.206)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1858"
                data-name="Rectangle 1858"
                width="16.864"
                height="14.67"
                transform="translate(412.725 154.405)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1859"
                data-name="Rectangle 1859"
                width="16.864"
                height="14.906"
                transform="translate(412.725 180.206)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1860"
                data-name="Rectangle 1860"
                width="16.864"
                height="14.67"
                transform="translate(412.725 154.405)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1861"
                data-name="Rectangle 1861"
                width="16.864"
                height="14.906"
                transform="translate(337.779 176.25)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1862"
                data-name="Rectangle 1862"
                width="16.864"
                height="14.67"
                transform="translate(337.779 150.45)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1863"
                data-name="Rectangle 1863"
                width="15.12"
                height="52.337"
                transform="translate(317.834 91.019)"
                fill="#f2f2f2"
            />
            <path
                id="Path_3732"
                data-name="Path 3732"
                d="M529.522,222.8l-36.773-43.748-73.815.675-44.778,43.614.9.582h-.323V314.64H529.423V223.922Z"
                transform="translate(-186.583 -89.289)"
                fill="#f2f2f2"
            />
            <path
                id="Path_3733"
                data-name="Path 3733"
                d="M565.094,179.238l-45.94,53.86v81.635H601.73V222.852Z"
                transform="translate(-258.89 -89.382)"
                fill="#e6e6e6"
            />
            <rect
                id="Rectangle_1864"
                data-name="Rectangle 1864"
                width="16.864"
                height="14.906"
                transform="translate(293.41 180.206)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1865"
                data-name="Rectangle 1865"
                width="16.864"
                height="14.67"
                transform="translate(293.41 154.405)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1866"
                data-name="Rectangle 1866"
                width="16.864"
                height="14.906"
                transform="translate(293.41 180.206)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1867"
                data-name="Rectangle 1867"
                width="16.864"
                height="14.67"
                transform="translate(293.41 154.405)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1868"
                data-name="Rectangle 1868"
                width="16.864"
                height="14.906"
                transform="translate(218.465 176.25)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1869"
                data-name="Rectangle 1869"
                width="16.864"
                height="14.67"
                transform="translate(218.465 150.45)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1870"
                data-name="Rectangle 1870"
                width="20.203"
                height="69.935"
                transform="translate(190.58 45.851)"
                fill="#f2f2f2"
            />
            <path
                id="Path_3734"
                data-name="Path 3734"
                d="M240.557,146.569,191.419,88.112l-98.635.9L32.951,147.293l1.209.777h-.432V269.29h206.7V148.07Z"
                transform="translate(-16.432 -43.939)"
                fill="#f2f2f2"
            />
            <path
                id="Path_3735"
                data-name="Path 3735"
                d="M288.089,88.36,226.7,160.33V269.414H337.044V146.639Z"
                transform="translate(-113.051 -44.063)"
                fill="#e6e6e6"
            />
            <rect
                id="Rectangle_1871"
                data-name="Rectangle 1871"
                width="22.535"
                height="19.918"
                transform="translate(157.943 165.026)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1872"
                data-name="Rectangle 1872"
                width="22.535"
                height="19.602"
                transform="translate(157.943 130.55)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1873"
                data-name="Rectangle 1873"
                width="22.535"
                height="19.918"
                transform="translate(157.943 165.026)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1874"
                data-name="Rectangle 1874"
                width="22.535"
                height="19.602"
                transform="translate(157.943 130.55)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1875"
                width="22.535"
                height="19.918"
                transform="translate(57.797 159.741)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1876"
                width="22.535"
                height="19.602"
                transform="translate(57.797 125.265)"
                fill="#fff"
            />
            <rect
                id="Rectangle_1877"
                width="483.25"
                height="1.003"
                transform="translate(0 224.903)"
                fill="#3f3d56"
            />
            <ellipse
                id="Ellipse_402"
                cx="14.588"
                cy="29.766"
                rx="14.588"
                ry="29.766"
                transform="translate(61.549 146.936)"
                fill="#3f3d56"
            />
            <path
                id="Path_3736"
                data-name="Path 3736"
                d="M253.033,604.293c-5.843-35.055-.059-69.984,0-70.332l1.137.193c-.059.347-5.809,35.092,0,69.95Z"
                transform="translate(-175.549 -378.869)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <rect
                id="Rectangle_1878"
                data-name="Rectangle 1878"
                width="14.96"
                height="1.153"
                transform="translate(75.788 177.356) rotate(-28.142)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <rect
                id="Rectangle_1879"
                width="1.153"
                height="14.961"
                transform="translate(61.866 174.852) rotate(-61.842)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <ellipse
                id="Ellipse_403"
                cx="28.533"
                cy="58.218"
                rx="28.533"
                ry="58.218"
                transform="translate(12.553 72.579)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <path
                id="Path_3737"
                data-name="Path 3737"
                d="M184.293,538.75c-11.412-68.473-.115-136.7,0-137.378l1.136.193c-.115.679-11.379,68.72,0,137Z"
                transform="translate(-140.029 -312.75)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1880"
                data-name="Rectangle 1880"
                width="29.261"
                height="1.153"
                transform="translate(40.663 132.564) rotate(-28.142)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1881"
                width="1.153"
                height="29.261"
                transform="translate(13.433 126.695) rotate(-61.842)"
                fill="#3f3d56"
            />
            <ellipse
                id="Ellipse_404"
                cx="39.045"
                cy="79.667"
                rx="39.045"
                ry="79.667"
                transform="translate(69.619 16.09)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <path
                id="Path_3738"
                data-name="Path 3738"
                d="M319.979,488.474c-15.611-93.666-.158-186.989,0-187.921l1.137.193c-.158.93-15.578,94.07,0,187.539Z"
                transform="translate(-206.757 -262.474)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1882"
                data-name="Rectangle 1882"
                width="40.041"
                height="1.153"
                transform="translate(108.186 98.362) rotate(-28.142)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1883"
                width="1.153"
                height="40.041"
                transform="matrix(0.472, -0.882, 0.882, 0.472, 70.923, 89.954)"
                fill="#3f3d56"
            />
            <ellipse
                id="Ellipse_405"
                cx="14.588"
                cy="29.766"
                rx="14.588"
                ry="29.766"
                transform="translate(422.078 146.936)"
                fill="#3f3d56"
            />
            <path
                id="Path_3739"
                data-name="Path 3739"
                d="M968.281,604.293c5.843-35.055.059-69.984,0-70.332l-1.136.193c.059.347,5.809,35.092,0,69.95Z"
                transform="translate(-532.961 -378.869)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <rect
                id="Rectangle_1884"
                data-name="Rectangle 1884"
                width="1.153"
                height="14.96"
                transform="translate(423.277 171.32) rotate(-61.858)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <rect
                id="Rectangle_1885"
                width="14.961"
                height="1.153"
                transform="translate(437.202 180.898) rotate(-28.158)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <ellipse
                id="Ellipse_406"
                cx="28.533"
                cy="58.218"
                rx="28.533"
                ry="58.218"
                transform="translate(443.185 72.579)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <path
                id="Path_3740"
                data-name="Path 3740"
                d="M1034.549,538.75c11.412-68.473.115-136.7,0-137.378l-1.136.193c.115.679,11.379,68.72,0,137Z"
                transform="translate(-566.008 -312.75)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1886"
                data-name="Rectangle 1886"
                width="1.153"
                height="29.261"
                transform="translate(445.791 119.782) rotate(-61.858)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1887"
                width="29.261"
                height="1.153"
                transform="translate(473.027 139.481) rotate(-28.158)"
                fill="#3f3d56"
            />
            <ellipse
                id="Ellipse_407"
                cx="39.045"
                cy="79.667"
                rx="39.045"
                ry="79.667"
                transform="translate(365.095 16.09)"
                fill="currentColor"
                className="text-primary"
            />{' '}
            {/* Replaced #f4b400 */}
            <path
                id="Path_3741"
                data-name="Path 3741"
                d="M896.993,488.474c15.611-93.666.158-186.989,0-187.921l-1.136.193c.158.93,15.578,94.07,0,187.539Z"
                transform="translate(-497.412 -262.474)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1888"
                data-name="Rectangle 1888"
                width="1.153"
                height="40.041"
                transform="translate(368.763 80.495) rotate(-61.858)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1889"
                width="40.041"
                height="1.153"
                transform="matrix(0.882, -0.472, 0.472, 0.882, 406.031, 107.835)"
                fill="#3f3d56"
            />
            <path
                id="Path_3742"
                data-name="Path 3742"
                d="M683.814,322.339l4.615-3.691c-3.585-.4-5.058,1.56-5.661,3.107a7.861,7.861,0,0,0-5.85.361l9.234,3.352A6.987,6.987,0,0,0,683.814,322.339Z"
                transform="translate(-388.232 -271.472)"
                fill="#3f3d56"
            />
            <path
                id="Path_3743"
                data-name="Path 3743"
                d="M458.814,257.339l4.615-3.691c-3.585-.4-5.058,1.56-5.661,3.107a7.861,7.861,0,0,0-5.85.361l9.234,3.352A6.987,6.987,0,0,0,458.814,257.339Z"
                transform="translate(-276.03 -239.058)"
                fill="#3f3d56"
            />
            <path
                id="Path_3744"
                data-name="Path 3744"
                d="M825.814,228.339l4.615-3.691c-3.585-.4-5.058,1.56-5.661,3.107a7.861,7.861,0,0,0-5.85.361l9.234,3.352a6.988,6.988,0,0,0-2.338-3.13Z"
                transform="translate(-459.044 -224.596)"
                fill="#3f3d56"
            />
            <path
                id="Path_3745"
                data-name="Path 3745"
                d="M835.3,660.652a6.979,6.979,0,0,0-3.495.938,7.511,7.511,0,0,0-12.548,5.579H842.3A7.014,7.014,0,0,0,835.3,660.652Z"
                transform="translate(-459.215 -441.548)"
                fill="#3f3d56"
            />
            <path
                id="Path_3746"
                data-name="Path 3746"
                d="M368.3,660.652a6.979,6.979,0,0,0-3.495.938,7.511,7.511,0,0,0-12.548,5.579H375.3A7.014,7.014,0,0,0,368.3,660.652Z"
                transform="translate(-226.333 -441.548)"
                fill="#3f3d56"
            />
            <path
                id="Path_3747"
                data-name="Path 3747"
                d="M607.3,660.652a6.979,6.979,0,0,0-3.495.938,7.511,7.511,0,0,0-12.548,5.579H614.3A7.014,7.014,0,0,0,607.3,660.652Z"
                transform="translate(-345.516 -441.548)"
                fill="#3f3d56"
            />
            <path
                id="Path_3748"
                data-name="Path 3748"
                d="M405.65,404.228H339.191v2.144h10.365v20.367H351.7V406.372h40.37v20.367h2.144V406.372H405.65Z"
                transform="translate(-169.147 -201.579)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1890"
                data-name="Rectangle 1890"
                width="66.459"
                height="2.144"
                transform="translate(170.175 196.235)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1891"
                data-name="Rectangle 1891"
                width="66.459"
                height="2.144"
                transform="translate(170.175 190.875)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1892"
                data-name="Rectangle 1892"
                width="66.459"
                height="2.144"
                transform="translate(170.175 185.515)"
                fill="#3f3d56"
            />
            <path
                id="Path_3749"
                data-name="Path 3749"
                d="M612.65,404.228H546.191v2.144h10.365v20.367H558.7V406.372h40.37v20.367h2.144V406.372H612.65Z"
                transform="translate(-272.373 -201.579)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1893"
                data-name="Rectangle 1893"
                width="66.459"
                height="2.144"
                transform="translate(273.949 196.235)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1894"
                data-name="Rectangle 1894"
                width="66.459"
                height="2.144"
                transform="translate(273.949 190.875)"
                fill="#3f3d56"
            />
            <rect
                id="Rectangle_1895"
                data-name="Rectangle 1895"
                width="66.459"
                height="2.144"
                transform="translate(273.949 185.515)"
                fill="#3f3d56"
            />
        </g>
    </svg>
);

export default function NotFound() {
    // For simplicity, this root not-found page might not be fully localized
    // or will redirect to a localized 404 if middleware handles it.
    // This page aims to be as minimal as possible.

    const { t, currentLanguage } = useTranslation();

    return (
        <div className="flex flex-col min-h-dvh bg-background">
            {' '}
            {/* Ensure full height */}
            <Navbar />
            {/* Adjusted min-height to account for navbar (h-14 is approx 3.5rem) */}
            <main className="flex flex-1 flex-col items-center justify-center space-y-8 p-6 text-center">
                <EmptyStreetIcon className="w-64 h-auto text-muted-foreground" />{' '}
                {/* Added SVG icon */}
                <div className="space-y-2">
                    <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
                        {t('notFound.title')}
                    </h1>
                    <p className="text-lg text-muted-foreground">
                        {t('notFound.message')}
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row items-center gap-4">
                    <Button asChild variant="default" size="lg">
                        <Link href={`/${currentLanguage}/`}>
                            <Home className="mr-2 h-5 w-5" />
                            {t('notFound.goToHomepage')}
                        </Link>
                    </Button>
                    {/* You might want to add a "Report Issue" button here eventually */}
                </div>
                <p className="text-sm text-muted-foreground">
                    {t('notFound.errorCode')}
                </p>
            </main>
        </div>
    );
}
